import {
	showChangePasswordModal,
	trackLeadsPageSignUp,
	autoOpenLauncherAfterSeconds,
	trackLauncherOnPageAfterSeconds,
} from '@bark/bark-core';
import { SellerResponseFlow } from '../components/leads/seller_response_flow';
import { SellerDashboard } from '../components/leads/seller_dashboard';
import { GHGAndCreditStatus } from "../components/leads/dashboard/ghg-credit-status";
import { SubscriptionFreeResponse } from "../components/leads/dashboard/subscription-free-response";
import { PurchaseCredits } from "../components/leads/dashboard/purchase-credits";
import { SellerDashboardProspectRescueFlow } from '../components/leads/prospect_rescue_flow';
import { DashboardFilters } from '../components/leads/dashboard_filters';
import { default as WhatIsBarkModal } from '../components/what-is-bark/what-is-bark-modal';
import { DashboardEmailTemplates } from '../components/leads/dashboard_email_templates';
import { SendEstimate } from '../components/estimate/send_estimate';
import { CallBuyerModal } from '../components/call-buyer/call-buyer-modal';
import { StarterPackFlowOverride } from '../components/leads/starter_pack_flow_override';
import { getLang } from '@bark/bark-core/src/helpers/locale';

export default async function () {
	try {
		var barkModalOpen = false;

		let { exposeSubscriptionUpsellEventsToWindow } = await import(
			'../components/subscription-upsell'
		);

		exposeSubscriptionUpsellEventsToWindow();

		const { exposeCreditCardModalToWindow, exportPaymentMethodsToWindow } = await import(
			'../components/payments'
		);
		exposeCreditCardModalToWindow();
		exportPaymentMethodsToWindow();

		if (showChangePasswordModal()) {
			const { runPasswordModal } = await import('@bark/bark-core');
			runPasswordModal();
		}

		WhatIsBarkModal();
        GHGAndCreditStatus();
		SubscriptionFreeResponse();
		SellerDashboard();
        PurchaseCredits();
        SellerDashboardProspectRescueFlow();
		StarterPackFlowOverride();
		DashboardFilters();
		SellerResponseFlow();
		SendEstimate();
		CallBuyerModal();
		DashboardEmailTemplates();

		trackLeadsPageSignUp();
		window.onload = () => {
			trackLauncherOnPageAfterSeconds(5);
			autoOpenLauncherAfterSeconds(5);

			if (window.Bark?.seller?.upsell_offer_active) {
				// Start a Hotjar recording for seller starter packs
				window.Bark.triggerHotjarRecording('seller_signup_conversion');
			}

			// Testimonals Video
			$('.comment-card .avatar-wrapper').click(function () {
				if (getLang() !== 'en') return;
				var videoSrc = $(this).data('src');

				barkModalOpen = ($('#whatIsBarkModal').data('bs.modal') || {})._isShown;

				if (videoSrc) {
					var videoModal = $('#videoModal');

					if (barkModalOpen) {
						$('#whatIsBarkModal').modal('hide');
					}

					videoModal.modal('show');
					videoModal.find('#video-iframe').attr('src', videoSrc);
				}
			});
		};

		$('#videoModal').on('hide.bs.modal', function (e) {
			$(this).find('#video-iframe').attr('src', '');
			if (barkModalOpen) {
				$('#whatIsBarkModal').modal('show');
			}
		});
	} catch (e) {
		console.log(e);
	}
}
